import { useEffect, useState } from "react";

// Email offuscata: l'indirizzo NON compare mai in chiaro nell'HTML servito.
// Viene ricomposto solo lato client dopo l'idratazione.
// Encoding: base64 di "user|domain" — è sufficiente per non farsi raccogliere
// da scraper che leggono l'HTML statico senza eseguire JS.
const ENCODED = "aW5mb3xsYWJvdHRlZ2FkZWxsZWNhcm5pZGFtYXJjby5pdA=="; // info | labottegadellecarnidamarco.it

function decode(): { email: string; href: string } {
  try {
    const raw = typeof atob === "function"
      ? atob(ENCODED)
      : Buffer.from(ENCODED, "base64").toString("utf-8");
    const [user, domain] = raw.split("|");
    const email = `${user}@${domain}`;
    return { email, href: `mailto:${email}` };
  } catch {
    return { email: "", href: "#" };
  }
}

type Props = {
  className?: string;
  children?: (email: string) => React.ReactNode;
  ariaLabel?: string;
};

export function ObfuscatedEmail({ className, children, ariaLabel = "Scrivici una email" }: Props) {
  const [data, setData] = useState<{ email: string; href: string } | null>(null);

  useEffect(() => {
    setData(decode());
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!data) {
      e.preventDefault();
      const d = decode();
      setData(d);
      window.location.href = d.href;
    }
  };

  if (!data) {
    return (
      <a
        href="#"
        onClick={handleClick}
        aria-label={ariaLabel}
        className={className}
      >
        {/* Placeholder non raccoglibile: mostrato solo prima dell'idratazione */}
        <span aria-hidden="true">email protetta</span>
      </a>
    );
  }

  // Dopo l'idratazione il link mostra l'indirizzo: il nome accessibile è il testo visibile
  // (un aria-label diverso violerebbe WCAG 2.5.3, «label in name»).
  return (
    <a href={data.href} className={className}>
      {children ? children(data.email) : data.email}
    </a>
  );
}

// Testo semplice (senza link), utile in frasi del tipo "scrivici a ...".
export function ObfuscatedEmailText({ className }: { className?: string }) {
  const [email, setEmail] = useState<string>("");
  useEffect(() => {
    setEmail(decode().email);
  }, []);
  return (
    <span className={className}>
      {email || <span aria-hidden="true">email protetta</span>}
    </span>
  );
}